function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import PropTypes from "prop-types";
import React from "react";
import { actions } from "../../utils/overlay-store"; // Use this if you want to control a modal's open/close state
// through a prop. Would be useful if you want to close a modal
// when a component is unmounted etc.

var ModalState = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalState, _React$Component);

  var _super = _createSuper(ModalState);

  function ModalState() {
    var _this;

    _classCallCheck(this, ModalState);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleLaunchModal", function () {
      var child = React.Children.only(_this.props.children);
      var dialog = /*#__PURE__*/React.cloneElement(child, {
        onClose: _this.handleRemove,
        onUnmount: _this.handleRemove
      });
      actions.launchModal(dialog);
      return typeof _this.props.onClick === "function" ? _this.props.onClick() : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemove", function () {
      if (typeof _this.props.onClose === "function") {
        _this.props.onClose();
      }

      return actions.removeModal();
    });

    return _this;
  }

  _createClass(ModalState, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        return this.handleLaunchModal();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (newProps.isOpen && !this.props.isOpen) {
        return this.handleLaunchModal();
      } else if (!newProps.isOpen && this.props.isOpen) {
        return actions.removeModal();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return actions.removeModal();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ModalState;
}(React.Component);

_defineProperty(ModalState, "displayName", "ModalState");

_defineProperty(ModalState, "propTypes", {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
});

export { ModalState as default };